<div class="image"
     [woa-background-image]="[{
         image: orderingContextModel.headerImage(),
         opacity: orderingContextModel.headerImageOpacity(),
         classes: 'theme-header-image-color-pair'
     }]">
    @if (showPageLogo()) {
        <woa-logo class="image-page-logo" [type]="'vertical'"></woa-logo>
    }
</div>
